import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatError, MatFormField } from '@angular/material/form-field';
import { Component, OnInit } from '@angular/core';
import { validateIBAN } from 'ngx-iban-validator';
import { MatInput } from '@angular/material/input';
import { IbanDirective } from '../../../../directives/iban.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { IbanFormatterPipe } from '../../../pipes/iban.pipe';

@Component({
  selector: 'app-formly-field-iban',
  standalone: true,
  templateUrl: './iban-form.component.html',
  styleUrl: './iban-form.component.scss',
  imports: [
    FormlyModule,
    ReactiveFormsModule,
    MatError,
    MatFormField,
    FormsModule,
    MatInput,
    IbanDirective,
    IbanFormatterPipe,
    TranslatePipe,
  ],
})
export class FormlyFieldIban
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  ngOnInit() {
    this.formControl.addValidators(validateIBAN);
    this.formControl.updateValueAndValidity();
  }
}
